import { useState, useEffect } from "react";
import { navLinks, heroData, images } from "../../data/mock";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? "bg-white/92 backdrop-blur-xl shadow-lg shadow-brand-700/8 py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo - clipped to hide slogan on small size */}
        <button
          onClick={() => scrollTo("#hero")}
          className="flex items-center group"
        >
          <img
            src={isScrolled ? images.logoDark : images.logoWhite}
            alt="Tu Iglesia App"
            className="h-14 w-auto object-contain transition-all duration-300"
          />
        </button>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled
                  ? "text-slate-600 hover:text-brand-700 hover:bg-brand-50"
                  : "text-white/85 hover:text-white hover:bg-white/10"
              }`}
            >
              {link.label}
            </button>
          ))}
          <Button
            onClick={() => scrollTo("#registro")}
            className={`ml-4 rounded-xl px-6 font-semibold transition-all duration-300 hover:scale-105 ${
              isScrolled
                ? "bg-brand-700 hover:bg-brand-800 text-white shadow-lg shadow-brand-700/25"
                : "bg-brand-light/20 backdrop-blur-sm hover:bg-brand-light/30 text-white border border-brand-light/30"
            }`}
          >
            Registrarse
          </Button>
        </nav>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden p-2 rounded-lg transition-colors ${
            isScrolled ? "text-slate-700" : "text-white"
          }`}
        >
          {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-white/95 backdrop-blur-xl shadow-2xl border-t border-brand-100 transition-all duration-500 ${
          mobileOpen
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 -translate-y-4 pointer-events-none"
        }`}
      >
        <div className="p-6 flex flex-col gap-2">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollTo(link.href)}
              className="text-left px-4 py-3 rounded-xl text-slate-700 hover:bg-brand-50 hover:text-brand-700 font-medium transition-colors"
            >
              {link.label}
            </button>
          ))}
          <Button
            onClick={() => scrollTo("#registro")}
            className="mt-3 bg-brand-700 hover:bg-brand-800 text-white rounded-xl py-3"
          >
            Registrarse
          </Button>
        </div>
      </div>
    </header>
  );
};
